import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [devLink, setDevLink] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      if (data.dev_reset_link) setDevLink(data.dev_reset_link);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full border border-neutral-300 px-4 py-3 outline-none focus:border-black bg-white text-sm";

  return (
    <div className="min-h-screen grid lg:grid-cols-2 font-sans">
      <div className="hidden lg:block relative bg-neutral-100">
        <img src="https://images.unsplash.com/photo-1605721911519-3dfeb3be25e7?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80" alt="" className="absolute inset-0 w-full h-full object-cover" />
      </div>
      <div className="flex flex-col px-6 py-10 lg:px-16 lg:py-16">
        <Link to="/" className="overline text-neutral-500 hover:text-black flex items-center gap-2" data-testid="back-home">
          <ArrowLeft size={14} /> d-Pod Gallery
        </Link>
        <div className="my-auto max-w-md w-full mx-auto">
          {sent ? (
            <div data-testid="forgot-sent">
              <MailCheck size={48} strokeWidth={1} className="text-emerald-600" />
              <h1 className="font-serif text-5xl font-light tracking-tight mt-6">Revisa tu email</h1>
              <p className="mt-6 text-neutral-600 leading-relaxed">
                Si <span className="font-medium text-neutral-900">{email}</span> está registrado en d-Pod Gallery, recibirás un enlace para restablecer tu contraseña en los próximos minutos. El enlace caduca en 1 hora.
              </p>
              {devLink && (
                <div className="mt-6 p-4 bg-amber-50 border border-amber-200 text-xs">
                  <div className="overline text-amber-800 mb-2">Modo desarrollo (sin email integrado)</div>
                  <p className="text-neutral-700 mb-2">Comparte este enlace manualmente con el usuario:</p>
                  <a href={devLink} className="font-mono text-[10px] break-all text-amber-900 underline" data-testid="dev-reset-link">{devLink}</a>
                </div>
              )}
              <Link to="/login" className="mt-10 inline-block bg-black text-white px-8 py-4 overline hover:bg-neutral-800 transition-colors">
                Volver al login
              </Link>
            </div>
          ) : (
            <>
              <h1 className="font-serif text-5xl font-light tracking-tight">Recuperar contraseña</h1>
              <p className="mt-4 text-sm text-neutral-500">Introduce tu email y te enviaremos un enlace para crear una nueva contraseña.</p>
              <form onSubmit={submit} className="mt-10 space-y-4" data-testid="forgot-form">
                <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="forgot-email" />
                {error && <p className="text-sm text-red-600">{error}</p>}
                <button disabled={loading} type="submit" className="w-full bg-black text-white py-4 overline hover:bg-neutral-800 transition-colors disabled:opacity-50" data-testid="forgot-submit">
                  {loading ? "..." : "Enviar enlace"}
                </button>
              </form>
              <p className="mt-8 text-sm text-neutral-500">
                <Link to="/login" className="text-black underline">← Volver al login</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
